import React from "react";
import { View } from "react-native";
import { useTranslateText } from "@/app/utils/translations";
import { TposMode } from "@/app/types/mode";
import { TouchableOpacity } from "../../../Buttons";
import { Text } from "../../../Text";
import { confirmOrderButtonStyles as styles } from "./styles";

type ConfirmOrderButtonProps = {
  onConfirmOrderButtonPress: () => void;
  disabled: boolean;
  basketTotal: string;
  buttonText: string;
};

const ConfirmOrderButton = ({
  onConfirmOrderButtonPress,
  disabled,
  basketTotal,
  buttonText,
}: ConfirmOrderButtonProps): JSX.Element => {
  const { t } = useTranslateText();
  const tposMode = TposMode.DRIVE_THRU; // useSelector(getTposMode);
  const showTotal = tposMode === TposMode.DRIVE_THRU;

  return (
    <TouchableOpacity
      style={styles.container}
      onPress={onConfirmOrderButtonPress}
      disabled={disabled}
      accessible
      accessibilityRole="button"
      accessibilityLabel="Confirm order button"
      accessibilityHint="Confirms and places the current order with the selected items"
      accessibilityState={{ disabled }}
    >
      <View
        style={[
          styles.button,
          !showTotal && styles.noTotal,
          disabled && styles.disabledButton,
        ]}
      >
        <Text style={styles.buttonText}>{t(buttonText)}</Text>
        {showTotal && (
          <View style={styles.totalContainer}>
            <Text
              style={styles.totalText}
              accessible
              accessibilityRole="text"
              accessibilityLabel="Total amount label"
            >
              {t("orderScreen.total")}
            </Text>
            <Text
              style={styles.buttonText}
              accessible
              accessibilityRole="text"
              accessibilityLabel="Total amount value"
            >
              {basketTotal}
            </Text>
          </View>
        )}
      </View>
    </TouchableOpacity>
  );
};

export default ConfirmOrderButton;
